
type Listener = () => void;

let siteKey: string | null = null;
let pending: Promise<void> | null = null;
let resolvePending: (() => void) | null = null;
const listeners = new Set<Listener>();

function emit(): void {
  for (const listener of listeners) listener();
}

export function subscribeHumanCheck(listener: Listener): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}


export function humanCheckSiteKey(): string | null {
  return siteKey;
}


export function requestHumanCheck(key: string): Promise<void> {
  if (pending) return pending;
  siteKey = key;
  pending = new Promise<void>((resolve) => {
    resolvePending = resolve;
  });
  emit();
  return pending;
}

export function completeHumanCheck(): void {
  const resolve = resolvePending;
  siteKey = null;
  pending = null;
  resolvePending = null;
  emit();
  resolve?.();
}
